<template>
    <div>
        <div class="d-flex justify-content-center align-items-center" style="height: 100vh">

            <div class="text-center" v-if="token!==null">
              <h3><b>Client:</b> {{token.client.name}}</h3>

              <form action="/" method="GET" >
                <input type="hidden" name="key" :value="token.token">
                <input v-if="parsedConfig" type="hidden" name="configuration" :value="parsedConfig">
                <input type="hidden" name="meta" value="meta123">
                <mdb-btn tag="button" color="primary" type="submit" ><mdb-icon icon="fingerprint" /> Verify with truid</mdb-btn>

              </form>

              <mdb-btn tag="button" color="primary" @click="modal=true" > Change Client Configuration</mdb-btn>
              <mdb-modal v-if="modal" @close="modal=false">
                <mdb-modal-header>
                  <mdb-modal-title tag="h4" class="w-100 text-center font-weight-bold">Client Configuration</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>
                  <div class="list-group list-group-light">
                    <a @click="addRemoveKey(key)"
                       class="list-group-item list-group-item-action px-3 border-0"
                       :class="{'active': Object.keys(configuration).includes(key), 'disabled': !disableKey(key)}"
                       v-for="key in configKeys"
                       :key="key"
                    >{{ key }}</a>
                  </div>
                </mdb-modal-body>
                <mdb-modal-footer class="justify-content-center">
                  <mdb-btn color="info" @click="modal=false">Close</mdb-btn>
                </mdb-modal-footer>
              </mdb-modal>
            </div>

        </div>

    </div>
</template>
<script>
    import axios from "axios";
    import Vue from "vue";
    import {mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,} from "mdbvue";
    export default {
        name: "About",
        components: {
          mdbModal,
          mdbModalHeader,
          mdbModalTitle,
          mdbModalBody,
          mdbModalFooter,
        },
        data() {
            return {
              query_params:null,
              token:null,
              modal: false,
              configKeys: ["demo_video", "face_liveness", "document_capture", "document_authenticity",
                "id_to_selfie_matching", "document_backside_capture", "verisys_verification",
                "personal_information_verification",
                "mobile_number_verification", "undertaking", "account_options"],
              configuration: {}
            }
        },
        computed: {
            parsedConfig() {
              return Object.keys(this.configuration).length > 0? JSON.stringify(this.configuration): null
            }
        },
        mounted() {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          this.query_params = params
          let http = axios.create({
            baseURL:process.env.VUE_APP_BASE_URL,
            headers:{
              "Authorization": `Api-Key ${process.env.VUE_APP_API_KEY}`
            }
          });
          if ('client' in this.query_params){
            http = axios.create({
              baseURL:process.env.VUE_APP_BASE_URL,
              headers:{
                "Authorization": `Api-Key ${this.query_params.client}`
              }
            });
          }
          http.post("/generate-token/").then(res=>{
            this.token = res.data
          })
        },
        methods: {
          addRemoveKey(key) {
            if (!Object.keys(this.configuration).includes(key)) {
              Vue.set(this.configuration, key, true)
            } else {
              Vue.delete(this.configuration, key)
              if (key === "document_capture") {
                ["document_authenticity", "document_backside_capture", "verisys_verification", "id_to_selfie_matching"].forEach(each => {
                  if (Object.keys(this.configuration).includes(each)) {
                    Vue.delete(this.configuration, each)
                  }
                })
              } else if (key === "face_liveness") {
                if (Object.keys(this.configuration).includes("id_to_selfie_matching")) {
                  Vue.delete(this.configuration, "id_to_selfie_matching")
                }
              } else if (key === "verisys_verification") {
                ["personal_information_verification", "mobile_number_verification"].forEach(each => {
                  if (Object.keys(this.configuration).includes(each)) {
                    Vue.delete(this.configuration, each)
                  }
                })
              }
            }
            console.log(JSON.stringify(this.configuration))
          },
          disableKey(key) {
            if (key === "id_to_selfie_matching") {
              return Object.keys(this.configuration).includes("face_liveness") && Object.keys(this.configuration).includes("document_capture");
            } else if (key === "document_authenticity" || key === "document_backside_capture" || key === "verisys_verification") {
              return Object.keys(this.configuration).includes("document_capture");
            } else if (key === "personal_information_verification" || key === "mobile_number_verification") {
              return Object.keys(this.configuration).includes("verisys_verification");
            }
            return true
          }
        }

    }
</script>
<style scoped>
a.active {
  color: white;
}
a.disabled {
  color: lightgray;
}
</style>
